var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 37,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#0082CE",
    fill: "#FFF",
    x: 0.5,
    y: 0.5,
    width: 112,
    height: 36,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.661 25.878c0 .944-.765 1.71-1.71 1.783H16.71c-.944-.074-1.709-.84-1.709-1.783v-3.302c0-.944.75-1.695 1.695-1.695h16.271c.945 0 1.71.766 1.71 1.71l-.015 3.287zM17.565 24.95h14.531",
    stroke: "#0082CE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.387 22.886a.426.426 0 1 0 0 .854.427.427 0 0 0 0-.854M32.096 22.886a.426.426 0 1 0 0 .854.428.428 0 0 0 0-.854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.492 8v10.17M19.746 12.746L24.492 8l4.745 4.746",
    stroke: "#0082CE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: -0.175,
    fill: "#0082CE"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45,
    y: 24
  }, "Upload")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.8ea6200b2bf99a4a6246109b66ae8d31.svg";
export { ForwardRef as ReactComponent };